import axios from 'axios';
import config from '@/config/constants.js';
import { firebase } from "@/config/firebase";

export default {
    namespaced: true,
    state: {
        status: '',
        services: [],
        logged: null,
        tenant_id: null,
        user_id: null,
    },
    mutations: {
        user_id(state, data) {
            state.user_id = data;
        },
        tenant_id(state, data) {
            state.tenant_id = data;
        },
        logged(state, data) {
            state.logged = data;
        },
        loading(state) {
            state.status = 'loading';
        },
        status(state, status) {
            state.status = status;
        },
        success(state) {
            state.status = '';
        },
        addServices(state, services) {
            state.services = [];
            for (const prop in services) {
                state.services.push({
                    text: services[prop].name,
                    value: services[prop].name,
                });
            }

        },
        updateLogged(state, data) {
            if (state.logged) {
                for (const i in data) {
                    if (["first_name", "last_name", "phone_number", "email", "profile_picture", "company_name", 'service', 'service_other', 'tag_line', 'selected_tags'].includes(i)) {
                        state.logged[i] = data[i];
                    }
                }
            }
        },
    },
    actions: {
        decode: function ({ commit }) {
            commit('loading');
            axios
                .post(config.api_url + 'web/retrieve_logged')
                .then(async (response) => {

                    let queryUsers = await firebase
                        .firestore()
                        .collection("users")
                        .get();

                    let queryDetailUsers = await firebase
                        .firestore()
                        .collection("tenants")
                        .doc(response.data.tenant_id)
                        .collection("users")
                        .get();


                    let user_global = queryUsers.docs.find(x => x['id'] === response.data.user_id);
                    let user_details;
                    let user;

                    if (user_global) {
                        let tenants = user_global.data()['tenants_list'];
                        let tenant = tenants.find(o => o.tenant_id === response.data.tenant_id)

                        if (tenant.role === "employee") {
                            user_details = queryDetailUsers.docs.find(x => x.data()['owner_id'] === user_global.id);
                            user_global = queryUsers.docs.find(x => x['id'] === user_details.data()['vendor_id']);
                            user_details = queryDetailUsers.docs.find(x => x.data()['owner_id'] === user_global.id);
                        }
                        if (tenant.role === "vendor") {
                            user_details = queryDetailUsers.docs.find(x => x.data()['owner_id'] === user_global.id);
                        }

                    }

                    if (user_global && user_details) {
                        user = {
                            ...user_details.data(),
                            ...user_global.data(),
                            tag_line: user_details.data()['tag_line'],
                            selected_tags: user_details.data()['selected_tags'],
                            id: user_details.id
                        }

                        commit('logged', user);
                        commit('user_id', user.owner_id);
                        commit('tenant_id', response.data.tenant_id);
                    }
                    commit('success');
                })
                .catch((errors) => {
                    console.error(errors);
                });

        },
        get_services: async function ({ commit, state }) {
            // eslint-disable-next-line no-async-promise-executor
            return new Promise(async function (resolve) {
                const dataServices = await axios.get(config.api_url + 'servises');
                const datos = dataServices.data['servises'];
                commit('addServices', datos);
                resolve(state.services);
            });
        },
        update_profile: async function ({ commit }, data) {
            commit('loading');

            const payload = {};
            const allowedFields = ['tenant_id', 'tenant_user_id', 'owner_id', 'first_name', 'last_name', 'phone_number', 'email', 'profile_picture', 'company_name', 'service', 'service_other', 'tag_line', 'selected_tags'];
            for (const key of allowedFields) {
                if (data[key] !== undefined && data[key] !== null && data[key] !== '') {
                    payload[key] = data[key];
                }
            }

            try {
                await axios.put(config.api_url + 'edit_vendor', payload);
                commit('updateLogged', payload);
            } catch (e) {
                console.error('[update_profile] Error:', e);
            }

            commit('success');
        }
    },
};